// extracted by mini-css-extract-plugin
export default {"emailText":"RegisterWithProvisionView-module__emailText--3G5mH"};